import { dateFromSecondsTimestamp, dateToTimeString, createDateFromTimeRangeAndDate } from "./common";
import { displayTimeRangeTooltip, getSlotUrl, getActiveUserId, getIsComUsingRequestSlots, createPutData } from "./summary_dws";
import config from './droppable_config';
import { getSlotToDate } from "./slot_helpers";
import { handleNewSlot } from "./summary_dws";
import { handleSlotDelete, handleRawSlotChange, resizeSlotDOMElementsForUser, handleLinkedSlotsStats } from "./summary_dws_table";
let droppable;

function handleDragStart(evt) {
  // Cancel slot drag if dragging the section inside the slot
  const target = evt.sensorEvent?.originalEvent?.target;
  if (target instanceof HTMLElement && target.closest('.section.draggable')) {
    evt.cancel();
    return;
  }

  $(evt.originalSource).show();
  const slotSourceEl = $(evt.source);
  const mirror = $(evt.mirror);
  slotSourceEl.addClass('droppable-source');
  $('.slot').addClass('droppable-sibling');
  $('.dropzones').addClass('active');
  mirror.addClass('droppable-source');
  mirror.find(".sections-overlay").hide();
  slotSourceEl.find(".sections-overlay").hide();
}

function handleMirrorMove(evt){
  const dropzone = $(evt.source).parent('.dropzone');
  const dropzones = dropzone.parent(".dropzones");
  const slotSourceEl = $(evt.source);
  const mirror = $(evt.mirror);
  // If not over a dropzone, then show original element in original position and hide mirror.
  if (dropzones.length === 0) {
    mirror.hide();
    return;
  }

  mirror.show();
  // Force width to remain same.
  slotSourceEl.width(`${$(evt.originalSource).width()}px`);

  const slotId = slotSourceEl.data('id');
  const slot = SlotMap[slotId];
  // Get target from and to hour in daily view
  const {from, to} = calculateFromAndToAfterDrag(dropzones.data("timestamp"), dropzone.data("timestamp-offset"), slot);

  // Show a preview of the new From and To in a tooltip
  displayTimeRangeTooltip(mirror, dateToTimeString(from), dateToTimeString(to));
}

function handleDragStop(evt) {
  const slotSourceEl = $(evt.source);
  removeDragClasses(slotSourceEl);

  const dropzone = $(evt.source).parent('.dropzone');
  const dropzones = dropzone.parent(".dropzones");
  const slotId = slotSourceEl.data('id');
  const slotBeforeEdit = structuredClone(SlotMap[slotId]);

  // If we didn't drop in a dropzone, then ignore the event and reset slot elements.
  if (!dropzones.length) {
    // TODO: import
    resizeSlotDOMElementsForUser(slotBeforeEdit.UserID);
    return;
  }
  
  if (slotBeforeEdit.RepeatKey && !confirm("このリピートシフトは解除され新規のシフトに変更されますが、よろしいですか？")) {
    $(`.slots-overlay.dropzone[data-user='${slotBeforeEdit.UserID}']`).append(slotSourceEl);
    resizeSlotDOMElementsForUser(slotBeforeEdit.UserID);
    return;
  }

  const {from, to} = calculateFromAndToAfterDrag(dropzones.data("timestamp"), dropzone.data("timestamp-offset"), slotBeforeEdit);
  const slotPutData = createPutData(slotBeforeEdit, from, to, dropzone.data('user'))
  slotPutData.isDWSDrag = true;

  const draggedToNewUser = slotBeforeEdit.UserID != slotPutData.userID;
  const isNotCreatedByActiveUser = slotBeforeEdit.CreatedBy != getActiveUserId() && slotBeforeEdit.CreatedBy == slotBeforeEdit.UserID;
  if (isNotCreatedByActiveUser && draggedToNewUser && getIsComUsingRequestSlots()) {
    $(`.slots-overlay.dropzone[data-user='${slotBeforeEdit.UserID}']`).append(slotSourceEl)
    alertModal.alert("希望シフトを設定している場合、シフト上でドラッグ＆ドロップをすることはできません。")
    return;
  }
  putSlotAfterDrag(slotBeforeEdit, slotPutData);
}

function calculateFromAndToAfterDrag(hourTimestampSeconds, offset, slot) {
  const timestamp = dateFromSecondsTimestamp(hourTimestampSeconds).valueOf() + offset;
  let {from, to} = calculateFromAndToFromDropzoneTimestamp(timestamp, slot);

  if (slot.LinkNext || slot.LinkPrev) {
    const linkedSlot = SlotMap[slot.LinkNext] || SlotMap[slot.LinkPrev];
    to = createDateFromTimeRangeAndDate(to, dateFromSecondsTimestamp(linkedSlot.FromUnix), getSlotToDate(linkedSlot));
  }

  return {from, to};
}

function calculateFromAndToFromDropzoneTimestamp(dropzoneFromTimestamp, slot) {
  const from = new Date(dropzoneFromTimestamp);
  const to = createDateFromTimeRangeAndDate(from, dateFromSecondsTimestamp(slot.FromUnix), dateFromSecondsTimestamp(slot.ToUnix));
  return {
    from,
    to
  };
}

function removeDragClasses(slotSourceEl) {
  $('.slot').removeClass('droppable-sibling');
  $('.dropzones').removeClass('active');
  slotSourceEl.find(".sections-overlay").show();
}

// TODO: In the case of a request slot, we hard refresh. Once we add request slots to our re-render templates, we can remove this.
function shouldRefreshAfterPut(slotBeforeEdit) {
  const hasRequestedSlot = slotBeforeEdit.RequestedSlotKey && slotBeforeEdit.RequestedSlot;
  const slotNotCreatedByActiveUser = slotBeforeEdit?.CreatedBy && slotBeforeEdit.CreatedBy != getActiveUserId();
  // Conditions for Refresh:
  // 1. if StackSlots settings is ON and Slot has Request Slot
  return getIsComUsingRequestSlots() && (hasRequestedSlot || slotNotCreatedByActiveUser);
}
// TODO: There are slight variations between how we handle slots after put for drag, draw, and resize. For example, not all cases return an addList. Once we can remove some of these inconsistencies, we can refactor this to a single function for all cases.
function putSlotAfterDrag(slotBeforeEdit, data) {
  $.put(addURLSuffix(getSlotUrl(), slotBeforeEdit.ID), data, function(response) {
    if (!response.success) {
      alertModal.alert(errors.SLOT.UPDATE);
      return;
    }

    // Hard Refresh when Request slot setting is ON and Slot is created by staff or not by active user
    // Needs refactor.
    if (shouldRefreshAfterPut(slotBeforeEdit)) {
      Refresh();
      return;
    }

    if (response.deleteList.length) {
      response.deleteList.forEach(slotId => {
        SlotModal.onDelete(slotId);
      });
    }
    let slot;
    if (response.addList && response.addList.length > 0) {
      response.addList.forEach(s => {
        slot = s;
        $(`#slot-${slot.ID}`).remove();
        handleSlotDelete(slot);
      })

      response.addList.forEach(s => {
        slot = s;
        SlotMap[slot.ID] = slot;
        handleRawSlotChange(slot);
        reloadOnRepeat(slot);
        handleNewSlot(slot);
      })

      // Stats requires special handling for linked slots.
      const isLinkedSlotsDrag = response.addList[0].LinkNext || response.addList[0].LinkPrev;
      if (isLinkedSlotsDrag) {
        handleLinkedSlotsStats(response.addList);
      } else {
        response.addList.forEach(s => handleRawSlotChange(s))
      }

    } else {
      slot = response.slot;
      $(`#slot-${slotBeforeEdit.ID}`).remove();
      handleSlotDelete(slot);
      SlotMap[slot.ID] = slot;

      if (slot.SectionSlots) {
        slot.SectionSlots.forEach((section) => {
          SlotMap[section.ID] = section
        })
      }

      handleRawSlotChange(slot);
      reloadOnRepeat(slot);
      handleNewSlot(slot);
    }
    if (slot.UserID != slotBeforeEdit.UserID) {
      resizeSlotDOMElementsForUser(slotBeforeEdit.UserID);
    }
    return;
  })
  .fail(function() {
    Refresh();
  });
}

// initDroppableOnSlot is used after a slot create or edit
export function initDroppableOnSlot(slot) {
  // Disable dragging for confirmed (locked) slots on small screens
  if (window.innerWidth <= 600 && slot.Locked === true) {
    return;
  }
  droppable.addContainer($(`#slot-${slot.ID}`).get(0));
}

export function initDrag() {
  const draggableSlotElements = Array.from(document.querySelectorAll('.slot.draggable')).filter((slotEl) => {
    // Disable dragging for confirmed (locked) slots on small screens
    const isLocked = slotEl.dataset.locked === "true";
    return !(window.innerWidth <= 600 && isLocked);
  });

  droppable = new Droppable.default(draggableSlotElements, config);

  droppable.on('drag:start', (evt) => handleDragStart(evt));
  droppable.on("mirror:move", (evt) => handleMirrorMove(evt));
  droppable.on('drag:stop', (evt) => handleDragStop(evt));
}
